import React, { useEffect, useRef, useState } from 'react';
import AppTitle from '../../../layouts/AppTitle';
import AppDatagridTable from '../../../layouts/AppDatagridTable';

import { useDispatch, useSelector } from 'react-redux';
import { getPageContent, submitForm } from '../../../../store/actions/ProductActions';
import AppLoader from '../../../pages/AppLoader';
import { ordersTable } from '../../../../utils/tableElements';
import moment from 'moment';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { resetActionValues } from '../../../../store/actions/AppActions';
import { billingForm } from '../../../../utils/formElements';
import _ from 'lodash';
import { Button, Chip } from '@mui/material';
import {
  convertTo12HourFormat,
  orderStatus,
  pickStatusColor,
} from '../../../../utils/appConstants';

import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import AppDialogBox from '../../../pages/AppDialogBox';

import { useReactToPrint } from 'react-to-print';

const UpdateOrderDetails = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();
  const printRef = useRef();
  const myDivRef = useRef(null);

  const allProducts = useSelector(state => state?.products?.allProducts);
  const token = useSelector(state => state?.auth?.token);
  const btnLoaderOne = useSelector(state => state?.app?.btnLoaderOne);
  const order = useSelector(state => state?.admin?.order);

  const billingAddress = order?.billingAddress;
  const product = order?.product;

  const [basicOrderDetails, setBasicOrderDetails] = useState({});
  const [status, setStatus] = useState();
  const [comment, setComment] = useState('');
  const [customizations, setCustomizations] = useState({});

  const [open, setOpen] = useState(false);

  useEffect(() => {
    dispatch(resetActionValues('SINGLE_ORDER_DETAILS', undefined));

    dispatch(getPageContent('getSingleOrderDetails', token, id));
  }, [id]);

  useEffect(() => {
    if (order) {
      let billingValues = {};
      setStatus(order?.status);
      billingForm.map(v => {
        billingValues = { ...billingValues, [v?.label]: order?.billingAddress?.[v?.name] };
      });

      setBasicOrderDetails({
        'Order Id': order?.orderId,
        'Order On': moment(order?.orderedOn).format('YYYY-MM-DD hh:mm A'),
        'Product Charges': `₹ ${order?.singeProductPrice?.toFixed(2)}`,
        'Transport Charges': `₹ ${order?.transportCharges?.toFixed(2)}`,
        'Total Price': `₹ ${order?.totalPrice?.toFixed(2)}`,
        'Payment Method': order?.paymentMethod,
        'Payment Status': order?.paymentStatus,
        'Ordered Batch': order?.orderedBatch,
        // 'Ordered Note': order?.orderNote,
      });

      if (
        order?.product?.customizationOptions ||
        order?.product?.specialCakeNote ||
        order?.orderNote ||
        order?.product?.selectedPrice
      ) {
        let values = {};

        if (order?.product?.customizationOptions) {
          values = {
            'Customization Charges': `₹ ${order?.product?.customizeCharges?.toFixed(2)}`,
            Flavour: order?.product?.customizationOptions?.flavour,
            Quantity: order?.product?.customizationOptions?.quantity,
          };
        }

        if (order?.product?.selectedPrice) {
          values = {
            ...values,
            Quantity: order?.product?.selectedPrice?.content,
          };
        }

        if (order?.product?.specialCakeNote) {
          values = { ...values, 'Special Cake Note': order?.product?.specialCakeNote };
        }

        if (order?.orderNote) {
          values = { ...values, 'Checkout Note': order?.orderNote };
        }

        if (!order?.product?.customizeCharges) {
          delete values['Customization Charges'];
        }
        setCustomizations(values);
      }

      scrollToProducts();
      // window.scrollTo(0, 400);
    }
  }, [order]);

  function scrollToProducts() {
    if (myDivRef.current) {
      myDivRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }

  const handleStatusChange = e => {
    const status = e?.target?.value;

    // if (window.confirm(`Are you sure to update order status as ${status}?`)) {
    //   const submitValues = { status, id };
    //   dispatch(submitForm('updateOrderStatus', token, submitValues, '', navigate));
    // }

    setComment('');
    setStatus(status);
    setOpen(true);
  };

  const handleModalClose = () => {
    window.location.reload();
  };

  const handleUpdateForm = () => {
    const submitValues = { status, id, deliveryComment: comment };
    dispatch(submitForm('updateOrderStatus', token, submitValues, '', navigate));
    setOpen(false);
    setComment('');
  };

  const handlePrint = useReactToPrint({
    contentRef: printRef,
  });

  return order ? (
    <div>
      <AppTitle title={'Order Details'} from={'Orders'} to='Details' link={'/admin/orders'} />

      <div ref={printRef} className='print-section' style={{ padding: '10px 20px' }}>
        <div>
          <b>Product Details:</b>
          <br />
          {product?.title}
          <br />
          {/* <b> Quantity:</b> {order?.product?.selectedPrice?.content}
          <br /> 
           </div>
        <hr />

        <div>
          <b>Customization Details</b> */}
          {customizations &&
            Object.keys(customizations).map((key, i) => (
              <div key={i}>
                <p>
                  <b>{key}: </b> <span>{customizations?.[key] ?? '-'}</span>{' '}
                </p>
              </div>
            ))}
        </div>
        <hr />
        <div>
          {/*  */}
          <b>Ordered ID:</b> {order?.orderId}
          <br />
          <b>Ordered On:</b> {moment(order?.orderedOn).format('DD/MM/YYYY hh:mm A')}
          <br />
          <b> Expected Delivery Date:</b>
          {product?.bufferingDays && moment(order?.expectedDeliveryDate).format('DD/MM/YYYY')}
          {order?.deliveryTimeSlots?.[0]
            ? ` | ${convertTo12HourFormat(order?.deliveryTimeSlots[0])} - ${convertTo12HourFormat(
                order?.deliveryTimeSlots[1]
              )}`
            : ''}
          <br />
          <b>Ordered Status:</b> {order?.status}
          <br />
          <b>Product Charges:</b> ₹ {order?.singeProductPrice?.toFixed(2)}
          <br />
          <b>Transport Charges:</b> ₹ {order?.transportCharges?.toFixed(2)}
          <br />
          <b>Total Price:</b> ₹ {order?.totalPrice?.toFixed(2)}
          <br />
          <b>Payment Status:</b> {order?.paymentStatus}
          <br />
          <b>Payment Method:</b> {order?.paymentMethod}
        </div>

        <hr />

        <div>
          <b>Customer Details:</b>
          <br />
          {billingAddress?.firstName} {order?.billingAddress?.lastName}
          <br />
          {billingAddress?.['Town/City']}, {billingAddress?.state}, {billingAddress?.zipCode}
          <br />
          {billingAddress?.address}
          <br />
          {billingAddress?.phone}, {billingAddress?.email}
        </div>
      </div>

      <div ref={myDivRef} style={{ minHeight: '70px' }}></div>

      <div className='my-8'>
        <div className='container'>
          <div className='d-flex justify-content-end mb-2 align-items-center'>
            <Button
              size='small'
              variant='contained'
              sx={{ mr: 1, display: { xs: 'none', sm: 'block' } }}
              onClick={handlePrint}
            >
              Print
            </Button>
            <Chip label={order?.status} color={pickStatusColor?.[order?.status] ?? 'primary'} />

            {status && (
              <Box sx={{ minWidth: 120, ml: 2 }}>
                <FormControl fullWidth>
                  <InputLabel id='demo-simple-select-label'>Status</InputLabel>
                  <Select
                    labelId='demo-simple-select-label'
                    id='demo-simple-select'
                    value={status}
                    onChange={handleStatusChange}
                    disabled={order?.status === 'Delivered'}
                  >
                    {orderStatus?.map(status => (
                      <MenuItem key={status} value={status}>
                        {status}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            )}
          </div>

          <div className='row'>
            <div className='col-12 mb-2'>
              <h2 className='color-gold'>{product?.title}</h2>
            </div>
            {Object.keys(basicOrderDetails).map((key, i) => (
              <div key={i} className='col-12 col-md-6'>
                <p>
                  <b>{key}: </b> <span>{basicOrderDetails?.[key] ?? '-'}</span>{' '}
                </p>
              </div>
            ))}
          </div>

          <hr />

          <div className='row'>
            <div className='col-12 mb-2'>
              <h2>Billing Address</h2>
            </div>

            {billingForm.map(v => (
              <div className='col-12 col-md-6' key={v?.name}>
                <p>
                  <b>{v?.label}: </b> <span>{order?.billingAddress?.[v?.name] ?? '-'}</span>{' '}
                </p>
              </div>
            ))}
          </div>

          {order?.paymentDetails && (
            <>
              <hr />
              <div className='row'>
                <div className='col-12 mb-2'>
                  <h2>RazorPay Details</h2>
                </div>

                {Object.keys(order?.paymentDetails).map((key, i) => (
                  <div key={i} className='col-12 col-md-6'>
                    <p>
                      <b>{key}: </b>{' '}
                      <span style={{ wordWrap: 'wrap' }}>
                        {order?.paymentDetails?.[key] ?? '-'}
                      </span>{' '}
                    </p>
                  </div>
                ))}
              </div>
            </>
          )}

          {customizations && Object.keys(customizations)?.length > 0 && (
            <>
              <hr />
              <div className='row'>
                <div className='col-12 mb-2'>
                  <h2>Customization Details</h2>
                </div>

                {customizations &&
                  Object.keys(customizations).map((key, i) => (
                    <div key={i} className='col-12 col-md-6'>
                      <p>
                        <b>{key}: </b> <span>{customizations?.[key] ?? '-'}</span>{' '}
                      </p>
                    </div>
                  ))}
              </div>
            </>
          )}

          {order?.deliveryComments
            ? Object.keys(order?.deliveryComments)?.length > 0 && (
                <>
                  <hr />
                  <div className='row'>
                    <div className='col-12 mb-2'>
                      <h2>Tracking Comments</h2>
                    </div>

                    {Object.keys(order?.deliveryComments).map((key, i) => (
                      <div key={i} className='col-12'>
                        <p>
                          <b>{key}: </b> <span>{order?.deliveryComments?.[key] ?? '-'}</span>{' '}
                        </p>
                      </div>
                    ))}
                  </div>
                </>
              )
            : ''}

          <hr />
          <div className='row'>
            <div className='col-12 mb-2'>
              <h2>Ordered Products</h2>
            </div>

            <div className='table-responsive'>
              <table className='cart-table table text-center align-middle mb-6'>
                <thead>
                  <tr>
                    <th>Product</th>
                    <th>Quantity/Flavour</th>
                    <th>Price</th>
                    <th>Transport charges</th>
                    <th>Subtotal</th>
                    <th>Expected Delivery Date</th>
                  </tr>
                </thead>
                <tbody className='border-top-0'>
                  {_.sortBy([order?.product], 'title')?.map((product, i) => (
                    <tr key={i}>
                      <th className='cart-thumb d-flex flex-wrap align-items-center justify-content-center'>
                        <img
                          src={`${product?.selectedImg ?? product?.files?.[0]?.path}`}
                          alt='Croissant Italy Cake'
                        />
                        <span style={{ minWidth: '200px' }}>{product?.title}</span>
                      </th>

                      <td>{order?.product?.selectedPrice?.content}</td>
                      <td>₹{product?.price?.toFixed(2)}</td>
                      <td>₹{order?.transportCharges?.toFixed(2)}</td>
                      <td>
                        ₹{(product?.price * product?.quantity + order?.transportCharges).toFixed(2)}
                      </td>
                      <td>
                        {product?.bufferingDays &&
                          moment(order?.expectedDeliveryDate).format('DD/MM/YYYY')}

                        {order?.deliveryTimeSlots?.[0]
                          ? ` | ${convertTo12HourFormat(
                              order?.deliveryTimeSlots[0]
                            )} - ${convertTo12HourFormat(order?.deliveryTimeSlots[1])}`
                          : ''}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <AppDialogBox
        title={'Add Comment'}
        setOpen={setOpen}
        open={open}
        size='sm'
        disableBackdropClick={false}
      >
        <div className='form-group'>
          <div className='d-flex'>
            <textarea
              className='form-field'
              name={'comment'}
              value={comment ?? ''}
              onChange={e => setComment(e?.target?.value)}
              placeholder='Add comment to notify to user...'
            />
          </div>
        </div>

        <div className='text-right mt-2 mb-3'>
          <Button variant='contained' onClick={handleUpdateForm}>
            Submit
          </Button>

          <Button variant='contained' className='mx-2' color='error' onClick={handleModalClose}>
            Cancel
          </Button>
        </div>
      </AppDialogBox>
    </div>
  ) : (
    <AppLoader />
  );
};

export default UpdateOrderDetails;
